import type { NotificationsReferential } from "./referential-notifications.type";
import type { UseReferentialOptions } from "@/entities/referential";

import { useReferential, REFERENTIAL_ENDPOINT } from "@/entities/referential";

export const useReferentialNotifications = (
  options?: UseReferentialOptions<NotificationsReferential[]>
) => {
  const { data, ...result } = useReferential<NotificationsReferential[]>(
    REFERENTIAL_ENDPOINT.NOTIFICATIONS,
    options
  );

  return {
    notifications: data ?? [],
    ...result,
  };
};
